import { Fragment } from 'react/jsx-runtime';

import type { IntegrationConnectionType, IntegrationProviderType } from '@/api/integration';
import { Separator } from '@/components/Separator';

import IntegrationConnectionListItem from './IntegrationConnectionListItem';

type Props = {
  provider: IntegrationProviderType;
  onDisconnect: (connection: IntegrationConnectionType) => void;
};

const IntegrationDetailConnectionList = ({ provider, onDisconnect }: Props) => {
  return provider?.connections.map((conn) => (
    <Fragment key={conn.id}>
      <Separator orientation="horizontal" size="large" />
      <IntegrationConnectionListItem
        provider={provider}
        connection={conn}
        onDisconnect={() => onDisconnect(conn)}
      />
    </Fragment>
  ));
};

export default IntegrationDetailConnectionList;
